import { render, staticRenderFns } from "./preview02.vue?vue&type=template&id=2458f36a&scoped=true"
import script from "./preview02.vue?vue&type=script&lang=js"
export * from "./preview02.vue?vue&type=script&lang=js"
import style0 from "./preview02.vue?vue&type=style&index=0&id=2458f36a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2458f36a",
  null
  
)

export default component.exports